import type { TravelFeatureConfig } from '../../../types/insurances/TravelFeatureConfig';

export const travel: TravelFeatureConfig = {
    overview: {
        details: {
            showContractedInsurances: true,
            showVariant: false,
            showPackage: true,
            showStartDateWithTime: false,
            showContractHolder: false,
            fallbackAssistancePhonesKey: null,
            fallbackAssistanceEmailsKey: null,
        },
        showLinkedCards: false,
    },
    settings: {
        details: {
            showStatus: false,
        },
    },
};
